/**
 * @generated SignedSource<<9ffda4c69d1af722633e320da092dbea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MicrosoftTodoTaskSelectorListTasksQuery$variables = {
  listId: string;
};
export type MicrosoftTodoTaskSelectorListTasksQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly microsoftTodo: {
        readonly listTasks: ReadonlyArray<{
          readonly externalId: string;
          readonly name: string;
        }>;
      } | null;
    };
  };
};
export type MicrosoftTodoTaskSelectorListTasksQuery = {
  response: MicrosoftTodoTaskSelectorListTasksQuery$data;
  variables: MicrosoftTodoTaskSelectorListTasksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "listId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "listId",
    "variableName": "listId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MicrosoftTodoTaskSelectorListTasksQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrosoftTodoUserNode",
                "kind": "LinkedField",
                "name": "microsoftTodo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v1/*: any*/),
                    "concreteType": "MicrosoftTodoTaskNode",
                    "kind": "LinkedField",
                    "name": "listTasks",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MicrosoftTodoTaskSelectorListTasksQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrosoftTodoUserNode",
                "kind": "LinkedField",
                "name": "microsoftTodo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v1/*: any*/),
                    "concreteType": "MicrosoftTodoTaskNode",
                    "kind": "LinkedField",
                    "name": "listTasks",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31de9585471aa95da902825fcc83559d",
    "id": null,
    "metadata": {},
    "name": "MicrosoftTodoTaskSelectorListTasksQuery",
    "operationKind": "query",
    "text": "query MicrosoftTodoTaskSelectorListTasksQuery(\n  $listId: String!\n) {\n  viewer {\n    integrations {\n      microsoftTodo {\n        listTasks(listId: $listId) {\n          name\n          externalId\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2266101a810b9e281b0beb3adf3dc062";

export default node;
